import axios from "axios"
import { Group } from "../models/group"
import { Service } from "../services/Service"
import StoreService from "../services/store"

const serverBaseURL = process.env.REACT_APP_API_BASE_URL
class GroupApi {
    public static async getGroup(groupId: string): Promise<Group> {
        const headers = await Service.getRequestHeaders()
        const response = await axios.get(`${serverBaseURL}/groups/${groupId}`, {
            headers,
        })
        return response.data
    }

    public static async getSetting(
        groupId: string,
        type?: string
    ): Promise<any> {
        const headers = await Service.getRequestHeaders()
        const token = await StoreService.getInstance().persistant.get("token")
        const authLink = process.env.REACT_APP_CUSTOMER_AUTH_LINK
        let params = ""
        if (type) {
            params += `type=${type}`
        }
        if (authLink) {
            if (params) {
                params += "&"
            }
            params += `link_auth=${authLink}`
        }
        const response = await axios.get(
            `${serverBaseURL}/groups/${groupId}/settings${
                params ? `?${params}` : ""
            }`,
            {
                headers,
            }
        )
        return response.data
    }

    public static async getGroups(showSuper: boolean): Promise<any> {
        const headers = await Service.getRequestHeaders()
        const response = await axios.get(
            `${serverBaseURL}/groups/list?showSuper=${showSuper}`,
            {
                headers,
            }
        )
        return response.data
    }

    public static async updateSettings(
        groupId: string,
        settings: any,
        type: string
    ): Promise<any> {
        const headers = await Service.getRequestHeaders()
        const response = await axios.patch(
            `${serverBaseURL}/groups/${groupId}/settings?type=${type}`,
            settings,
            {
                headers,
            }
        )
        if (response.status === 200) {
            return response.data
        }
        return undefined
    }

    /**
     * setBarConfig
     */
    public static async setBarConfig(
        settings: {
            primaryBgd?: string
            secondaryBgd?: string
            primaryColor?: string
            secondaryColor?: string
        },
        groupId: string
    ): Promise<string | undefined> {
        const headers = await Service.getRequestHeaders()

        const response = await axios.patch(
            `${serverBaseURL}/groups/${groupId}/settings/bar`,
            settings,
            {
                headers,
            }
        )
        if (response.status === 200) {
            return response.data
        }
        return undefined
    }

    public static async getModules(groupId: string): Promise<any> {
        const headers = await Service.getRequestHeaders()
        const response = await axios.get(
            `${serverBaseURL}/groups/${groupId}/modules`,
            {
                headers,
            }
        )
        return response.data
    }

    /**
     * create groupe
     */
    public static async createGroup(group: any): Promise<any> {
        const headers = await Service.getRequestHeaders()
        const response = await axios.post(
            `${serverBaseURL}/group`,

            group,

            {
                headers,
            }
        )
        if (response.status === 200) {
            return response.data
        }
        return undefined
    }

    public static async updateGroup(groupId: string, group: any): Promise<any> {
        const headers = await Service.getRequestHeaders()

        const response = await axios.patch(
            `${serverBaseURL}/group/${groupId}`,

            group,

            {
                headers,
            }
        )
        if (response.status === 200) {
            return response.data
        }
        return undefined
    }

    public static async deleteGroup(groupId: string): Promise<void> {
        const headers = await Service.getRequestHeaders()
        const response = await axios.delete(
            `${serverBaseURL}/group/${groupId}`,
            {
                headers,
            }
        )
        return response.data
    }

    public static async getByOwner(owner?: string): Promise<any> {
        const headers = await Service.getRequestHeaders()
        const response = await axios.get(
            `${serverBaseURL}/groups/owner${owner ? `?owner=${owner}` : ""}`,
            {
                headers,
            }
        )
        return response.data
    }

    public static async getAvailableGroups(userId: string): Promise<any> {
        const headers = await Service.getRequestHeaders()
        const response = await axios.get(
            `${serverBaseURL}/groups/available/${userId}`,
            {
                headers,
            }
        )
        return response.data
    }
}
export default GroupApi
